import { Button, Modal } from "antd";
import Password from "../PasswordTable";
import ModalContent from "./ModalContent";
import React, { Component } from 'react';
import { isPro } from '../../utils';

class PasswordManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
		};
		this.isReloadPasswords = false;

		this.addNewPassword = this.addNewPassword.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

	addNewPassword() {
		this.setState({ visible: true });
	}

	handleCancel(isReload = false) {
		this.isReloadPasswords = isReload;
		this.setState(
			{
				visible: false,
			}
		);
	};

	render() {
		const { visible } = this.state;
		return (
			<div>
				<Modal
					style={{ marginLeft: '180px', marginRight: '20px' }}
					title='Add New Password'
					visible={visible}
					onCancel={() => this.handleCancel(false)}
					maskClosable={false}
					footer={null}
					width='auto'
				>
					{
						<ModalContent
							closeModal={() => this.handleCancel(true)}
						></ModalContent>
					}
				</Modal>
				<p style={{ marginTop: 0 }}>
					<a target="_blank" rel="noopener" href="https://passwordprotectwp.com/docs/master-passwords-unlock-all-protected-content/?utm_source=user-website&utm_medium=settings-master-pwd&utm_campaign=ppwp-free">Unlock all password protected posts</a> at once with a single password. With Pro version, Master passwords can unlock all individual, partial content protection on Pages and Custom Post Types as well.
				</p>
				<Button id="ppw-add-master-password" onClick={(evt) => this.addNewPassword()} type="primary" style={{ marginBottom: 16 }}>
					Add New
				</Button>
				<span><i title="Refresh Data" style={{ marginTop: '10px' }} className="fa fa-refresh fa-lg pup-reload " onClick={(evt) => this.handleCancel(true)}></i></span>
				<Password callNotReload={() => this.isReloadPasswords = false}
					isReload={this.isReloadPasswords}></Password>
			</div>
		);
	}
}

export default PasswordManager;



// WEBPACK FOOTER //
// ./components/PasswordManager/index.js